<template>
   <div>
    <loader :is-visible="isLoading"></loader>
    <div class="container">
        <div class="container-post">
            <div class="form-modal">
                <div> 
                    <div class="section-modal">
                        <button  class="close" @click="back()">
                            
                        </button>
                        <div class="wrapper">
                            <p>Banner</p>
                            <input id="assetUpload" type="file" accept="image/*" @change="onAddFile($event)" hidden> 
                            <div class="mg-top1">
                                <img class="imgUpload" v-if="assetImgUrl" :src="assetImgUrl" alt="">
                                <button class="btn-upload mg-top1 mg-right" @click="chooseFiles()">Choose Image</button>
                                <!-- <button v-if="assetImgUrl" class="btn-upload" @click="removeImage()">Delete Image</button> -->
                            </div>
                            <div class="input-data mg-top">
                                <input type="text" required v-model="order_id">
                                <div class="underline"></div>
                                <label>Order Id</label>
                            </div>
                            <div class="input-data mg-top">
                                <input type="text" required v-model="name">
                                <div class="underline"></div>
                                <label>Name</label>
                            </div>
                            <div class="input-data mg-top">
                                <input type="text" required v-model="title">
                                <div class="underline"></div>
                                <label>Title</label>
                            </div>
                            <div class="text-area mg-top">
                                <textarea v-model="description" required></textarea>
                                <div class="underline"></div>
                                <label>Description</label>
                            </div>
                        </div>
                    </div>
                </div>        
                <div class="btn-heading">
                     <p class="mg-top" v-if="errors.length">
                        <b>Please correct the following error(s):</b>
                        <ul>
                            <li class="red" v-for="(error,index) in errors" :key="index">{{ error }}</li>
                        </ul>
                    </p>

                    <button class="btn-add mg-top1" @click="validation(id != 0 ? 'update' : 'add')">
                        <!-- Add Post -->
                        {{id != 0? 'Update' : 'Add'}} Post
                    </button>
                </div>     
            </div>
        </div>
    </div>
   </div>
</template>

<script>
import Loader from './../components/Loader.vue';
import alert from './../commons/alert.helper';
import axios from 'axios';

import auth from '@/service/auth.js'

export default {
    name: "AspirasiFormPerindo",
    data() {
        return {
            isLoading: false,
            showModal: false,
            id: '',
            assetImage: null,
            assetImgUrl : null,
            name: '',
            title: '',
            description: '',
            featured: '',
            order_id: '',
            errors: []
        }
    },
    methods: {
        validation(type) {
            this.errors = []
            
            if (!this.order_id) this.errors.push('* OrderId required')
            if (!this.assetImage) this.errors.push('* Image required')
            if (!this.name) this.errors.push('* Name cannot be empty')
            if (!this.title) this.errors.push('* Title required')
            if (!this.description) this.errors.push('* Description required')
            

            if (this.errors.length > 0) {
                return
            } else if (type === 'add') {
                this.addPerindo()
            } else if (type === 'update') {
                this.updatePerindo()
            }
        },
        async addPerindo() {
            const res = await auth.checkAuth(this.$route.fullPath)
            if (res == false) {
                localStorage.clear()
                alert.failed('Unauthorized Token', () => this.$router.push('/login'))
            } else {
                try {
                    this.isLoading = true
                    const formData = new FormData()
                    
                    formData.append('order_id', this.order_id)
                    formData.append('asset', this.assetImage)
                    formData.append('name', this.name)
                    formData.append('title', this.title)
                    formData.append('description', this.description)
    
                    const response = await axios.post('/content/aspirasiperindo', formData)
                    this.isLoading = false
    
                    console.log(response)
                    if(response.status == 200) {
                        alert.success('Add data success', () => this.$router.go(-1))
                    }
    
                } catch (error) {
                    console.log(error)
                }
            }
        },
        async getDataPerindo() { 
                let dataId = localStorage.getItem('dataPerindoById')
                
                let data = JSON.parse(dataId)

                this.order_id = data.order_id
                this.assetImage = data.asset
                this.assetImgUrl = data.asset
                this.name = data.name
                this.title = data.title
                this.description = data.description
        },
        async updatePerindo() {
            const res = await auth.checkAuth(this.$route.fullPath)
            if (res == false) {
                localStorage.clear()
                alert.failed('Unauthorized Token', () => this.$router.push('/login'))
            } else {
                try {
                    this.isLoading = true
                    const formData = new FormData()
                    
                    formData.append('id', this.id)
                    formData.append('order_id', this.order_id)
                    formData.append('asset', this.assetImage)
                    formData.append('name', this.name)
                    formData.append('title', this.title)
                    formData.append('description', this.description)
    
                    const response = await axios.patch(`/content/aspirasiperindo/${this.id}`, formData)
                    this.isLoading = false
    
                    console.log(response)
                    if(response.status == 200) {
                        alert.success('Update data success', () => this.$router.go(-1))
                    }
    
                } catch (error) {
                    console.log(error)
                    this.isLoading = false
                    alert.failed('Update data failed')
                }
            }
        },
        onAddFile (e) {
            console.log(e)
            this.assetImage = e.target.files[0]
            this.assetImgUrl = URL.createObjectURL(this.assetImage)
            console.log('asset', this.assetImage)
            console.log('assetUrl', this.assetImgUrl)
        },
        chooseFiles() {
            document.getElementById("assetUpload").click()
        },
        // removeImage() {
        //     this.assetImage =  ''
        //     this.assetImgUrl = ''
        // },
        back() {
            this.$router.go(-1)
        }
    },
    components: {
        Loader
    },
    created() {
        this.id = this.$route.params.id
        if(this.id != 0) {
            this.getDataPerindo();
        }
    },
    
}
</script>